import { useTranslation } from 'react-i18next';
import { Url } from '@wix/da-url';
import GhostButton from '@wix/da-ds/pkg/Buttons/GhostButton';
import AddIcon from '@wix/da-ds/pkg/Icons/16x16/Add';

import s from './EmptyState.scss';

interface Props {
  onAddProfile: () => void;
}

const EmptyState: React.FC<Props> = ({ onAddProfile }) => {
  const { t } = useTranslation();

  return (
    <div className={s['root']}>
      <img
        src={Url.staticCDNLink('/eclipse/global/svg/il15-1.svg')}
        alt={t('artsAndCraftsDeviationPopup.form.shippingProfile.label')}
      />
      <p className={s['title']}>{t('manageShippingProfiles.emptyState.message')}</p>
      <p className={s['subtitle']}>{t('manageShippingProfiles.emptyState.description')}</p>
      <GhostButton size="medium" variant="main" icon={AddIcon} onClick={onAddProfile}>
        {t('manageShippingProfiles.emptyState.newProfile')}
      </GhostButton>
    </div>
  );
};

EmptyState.displayName = 'EmptyState';
export default EmptyState;
